import { FC } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import LastRow from 'Molecules/LastRow/LastRow';

interface ProjectsTableLastRowProps {
  isOdd: boolean;
  tableName: string;
  onLastRowInView: (inView: boolean) => void;
}

const ProjectsTableLastRow: FC<ProjectsTableLastRowProps> = ({
  isOdd,
  tableName,
  onLastRowInView,
}) => {
  return (
    <LastRow
      isOdd={isOdd}
      tableName={tableName}
      onLastRowInView={onLastRowInView}
    >
      {({ rowRef, rowStyles, columnStyles, columnChildStyles }) => (
        <tr
          ref={rowRef}
          className={rowStyles}
          aria-label={`${tableName}__last-row`}
        >
          <td className={tailwindOverride('w-32', columnStyles)}>
            <div className={tailwindOverride('w-3/5', columnChildStyles)} />
          </td>
          <td className={tailwindOverride('w-72', columnStyles)}>
            <div className={tailwindOverride('w-3/4', columnChildStyles)} />
          </td>
          <td className={columnStyles}>
            <div className={tailwindOverride('w-2/4', columnChildStyles)} />
          </td>
          <td className={columnStyles}>
            <div className={tailwindOverride('w-1/4', columnChildStyles)} />
          </td>
          <td className={columnStyles}>
            <div className={tailwindOverride('w-1/4', columnChildStyles)} />
          </td>
          <td className={columnStyles}>
            <div className={tailwindOverride('w-1/4', columnChildStyles)} />
          </td>
          <td className={columnStyles}>
            <div className={tailwindOverride('w-1/4', columnChildStyles)} />
          </td>
        </tr>
      )}
    </LastRow>
  );
};

export default ProjectsTableLastRow;
